import React, { useContext } from "react";
import "../css/vineHome.css";
import "../css/shop.css";
import { LanguageContext } from "../LanguageContext";

export const Shop = (props) => {
  const { language = 'sr' } = useContext(LanguageContext) || {};
  const shopText = {
    sr: {
      onlineTitle: 'Poručite online',
      onlineDesc: 'Poručivanje direktno sa našeg sajta. Kliknite da posetite MCC web prodavnicu.',
      beograd: 'Beograd',
      noviSad: 'Novi Sad',
      vojvodina: 'Vojvodina',
      vinoteke: 'Vinoteke',
      restorani: 'Restorani',
      hoteli: 'Hoteli',
      phoneLabel: 'Tel:',
      linkText: 'Kliknite da posetite MCC web prodavnicu.',
    },
    en: {
      onlineTitle: 'Order online',
      onlineDesc: 'Order directly from our website. Click to visit the MCC web shop.',
      beograd: 'Belgrade',
      noviSad: 'Novi Sad',
      vojvodina: 'Vojvodina',
      vinoteke: 'Wine shops',
      restorani: 'Restaurants',
      hoteli: 'Hotels',
      phoneLabel: 'Phone:',
      linkText: 'Click to visit the MCC web shop.',
    },
  };

  const beogradWine = [
   // { name: "Enoteka Fino Vino", address: "Pop Lukina 6, Stari Grad", phone: "011/403-0962"" },
    { name: "Ours Vinoteka & Rakija Shop", address: "Ilije Stojadinovića 63, Čukarica", phone: "062/244111", website: "https://ours.rs/" },
    { name: "Truffle Shop", address: "Tadije Sondermajera 12, Novi Beograd"},
    { name: "Truffle Shop 2", address: " Pere Velemirovica 21",},
    { name: "Srpska Kuća Vina", address: "Antifašističke borbe 15, Novi Beograd", phone: "069/2137475", website: "www.enotria.rs" },
    { name: "Enoteka Premier", address: "Vojvođanska 63, lokal 13, Novi Beograd", phone: "+381 63 86 38 217",  address2: "Bul. Zorana Đinđića 125đ" },
    { name: "Atelje Poklona", address: "Tržni centar Fontana, Vojvode Stepe 8, lokal 3." },
   // { name: "Vinoteka Ukusa", address: "Nikole Tesle 2, Zemun", phone: "+381 63 317 306", },
    { name: "Stara Kapetanija shop", address: "Kej Oslobođenja 8, Zemun", phone: "011/316-1965",  },
    { name: "Vinoteka Vino I Vinogradarstvo - Vina Mosaica", address: "Zmaj od Noćaja 9, Dorćol", info: "Vino će biti isporučena u roku od 48h." },
   // { name: "Vinomond", address: "Lagumska 16, Zemun", phone: "011/277-3023",  },
   // { name: "Drink Story - Vinoarija", address: "Jedaneste krajiške divizije 72, Rakovica", phone: "069/1991961" },
  ];

  const beogradRestaurants = [
    { name: "Madera", address: "Bul. Kralja Aleksandra 43, Tašmajdan" },
    { name: "Red Queen", address: "Beograd na vodi" },
    { name: "Buda Bar", address: "Beograd na vodi" },
   // { name: "Lavina", address: "Djordja Stanojevica 9v, Belvil" },
    { name: "Shangri La Sushi", address: "Galerija, Beograd na vodi" },
    { name: "Supreme Steak House", address: "Galerija, Beograd na vodi" },
   // { name: "Savanova", address: "Savsko šetalište bb, Beograd na vodi" },
    { name: "Vegangelov", address: "Gospodara Jovanova 42a" },
    { name: "Radost Fina Kuhinjica", address: "Pariska 3" },
    { name: "Stara Kapetanija", address: "Zemunski Kej 8, Zemun" },
    { name: "Zelen", address: "Hadzi Milentijeva 13" },
   // { name: "Bahus Inn", address: "Bul. Nikole Tesle bb, Zemun" },
   // { name: "Malo Korzo - Panonija", address: "Zrenjaninski put 158a, Borča" },
   // { name: "Trio Gastro Pub", address: "Ćirila i Metodija 23a, Stara Pazova" },
  ];

  const beogradHotels = [
    { name: "HILTON", address: "Kralja Milana 35" },
    { name: "CROWN PLAZA", address: "Vladimira Popovica 10" },
   // { name: "SQUARE NINE", address: "Studentski trg 9" },
   // { name: "SAINT TEN HOTEL", address: "Svetog Save 10" },
  ];

  const noviSadWine = [
   // { name: "UNIVEREXPORT - UNIVER ORGANA", address: "Nikole Pasiće 25", phone: "021/525-132" },
   { name: "VINA VOJVODINE", address: "Mite Ruzica 2",  },
   { name: "WINE NOT", address: "Preradovićeva 12, Petrovaradin" },
    { name: "UNIVEREXPORT - PROMENADA", address: "Bulevar oslobođenja 119, suteren", phone: "021/215-6371" },
   //{ name: "NANA - VINO, RAKIJA SHOP BAR", address: "Dunavska 17", phone: "069/2761425" },
   // { name: "KORPA DELI MARKET", address: "Veselina Maslašea 2", phone: "021/2102523 mob: 064/647-6370" },
    { name: "ZDRAVOLOGIJA", address: "Bul. Kralja Petra 7", phone: "021/6320504 mob: 064/643-4599" },
    { name: "KRIVINA", address: "Sremska 9", phone: "061/2323866" },
    { name: "TEPLICA - EKOLOŠKA PRODAVNICA", address: "Petra Drapsina 18, suteren", phone: "062/935-7911" },
    { name: "SLATINA", address: "Veselina Maslašea 32", phone: "063/724-2784" },
   // { name: "VINO I VANILI WINE SHOP BAR", address: "Žitni trg 20", phone: "065/543-2200" },
  ];

  const noviSadRestaurants = [
    { name: "POSH ORGANIC", address: "Svetozara Miletica 11" },
    { name: "PARK NOVI RESTORAN", address: "Rodoljuba Colakovica " },
    { name: "Tako je suđeno", address: "Ribnjak - Gornji Put 15" },
    { name: "Garden I", address: "Vase Stajića 27" },
    { name: "PIVNICA TATA BRADA", address: "Mite Ruzica 4" },
    { name: "I Beer Concept Bar", address: "Danila Kiša 12" },
    { name: "Caffe Sedmica i Picerija Sedmica", address: "Bul. Kralja Petra 7", phone: "064/1082585" },
    
   // { name: "BEERAJ", address: "Trg Republike 18/L5", phone: "063/761-5877" },
   // { name: "Udruženje Klub Ljubitelja Pasti", address: "Maksima Gorkog 17" },
  ];

  const vojvodina = [
    { name: "DVE KULE RESORT", address: "Bacinci" },
    { name: "KOTA 111 Country club&resort", address: "Potez Handor Silbas" },
    { name: "ETNO RESTORAN TRECA RAMPA", address: "Čurug" },
   // { name: "Premier Aqua Hotel", address: "Martina Klisaca 16, Vrdnik" },
    { name: "Etno kompleks Vrdnicka Kula", address: "Potez pod kulom bb, Vrdnik" },
    //{ name: "Hotel Elite Palic", address: "Park Heroja 15, Palic" },
    { name: "Salas Idila", address: "Obrovacki put, Backa Palanka" },
   // { name: "Stara Kuca", address: "Ive Lole Ribara 84, Backa Palanka" },
  ];

  return (
    <div id="shop" style={{ paddingTop: 150 }}>
      <div className="shop-container">
        <div className="section-title">
          <h2>{shopText[language].onlineTitle}</h2>
        </div>

        <div className="shop-online-grid">
          <a href="https://mccvino.com/" target="_blank" rel="noopener noreferrer" className="wine-card-link">
            <div className="wine-card">
              <div className="wine-card-image">
                <img src="img/logo.png" alt="MCC Vino" className="img-responsive" />
              </div>
              <div className="wine-card-content">
                <h3>MCC Vino</h3>
                <p>{shopText[language].onlineDesc}</p>
              </div>
            </div>
          </a>
        </div>

        <div className="shop-locations-wrapper">
          <div className="shop-location-section">
            <h2>{shopText[language].beograd}</h2>
            <h3 className="subcategory-title">{shopText[language].vinoteke}</h3>
            {beogradWine.map((location, index) => (
              <div key={index} className="location-card">
                <h4>{location.name}</h4>
                <p>{location.address}</p>
                {location.address2 && <p>{location.address2}</p>}
                {location.phone && <p>{shopText[language].phoneLabel} {location.phone}</p>}
                {location.website && <p>{location.website}</p>}
                {location.info && <p>{location.info}</p>}
              </div>
            ))}
            <h3 className="subcategory-title">{shopText[language].restorani}</h3>
            {beogradRestaurants.map((location, index) => (
              <div key={index} className="location-card">
                <h4>{location.name}</h4>
                <p>{location.address}</p>
                {location.phone && <p>{shopText[language].phoneLabel} {location.phone}</p>}
              </div>
            ))}
            <h3 className="subcategory-title">{shopText[language].hoteli}</h3>
            {beogradHotels.map((location, index) => (
              <div key={index} className="location-card">
                <h4>{location.name}</h4>
                <p>{location.address}</p>
              </div>
            ))}
          </div>

          <div className="shop-location-section">
            <h2>{shopText[language].noviSad}</h2>
            <h3 className="subcategory-title">{shopText[language].vinoteke}</h3>
            {noviSadWine.map((location, index) => (
              <div key={index} className="location-card">
                <h4>{location.name}</h4>
                <p>{location.address}</p>
                {location.phone && <p>Tel: {location.phone}</p>}
              </div>
            ))}
            <h3 className="subcategory-title">{shopText[language].restorani}</h3>
            {noviSadRestaurants.map((location, index) => (
              <div key={index} className="location-card">
                <h4>{location.name}</h4>
                <p>{location.address}</p>
                {location.phone && <p>{shopText[language].phoneLabel} {location.phone}</p>}
              </div>
            ))}
            <h2>{shopText[language].vojvodina}</h2>
            {vojvodina.map((location, index) => (
              <div key={index} className="location-card">
                <h4>{location.name}</h4>
                <p>{location.address}</p>
                {location.phone && <p>Tel: {location.phone}</p>}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Shop;
             